/**
 * A consolidation SKU is "PK" + the consolidation id (backend `Skuable`), and
 * the API sends it either as that string (`consolidation.sku`) or as the bare
 * `consolidation_id`. The two helpers below are the only places that know it.
 */

/** The SKU the backend gives the consolidation with this id. */
export const formatConsolidationSku = (id: number): string => `PK${id}`;

/** The numeric id from either form of the SKU, or null when there is none. */
export const extractConsolidationId = (
  value: number | string | null | undefined,
): number | null => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value !== "string") {
    return null;
  }

  const normalizedValue = value.startsWith("PK") ? value.slice(2) : value;
  const parsedValue = parseInt(normalizedValue, 10);

  return Number.isNaN(parsedValue) ? null : parsedValue;
};
